<template>
  <div>
    <div class="row mb-2">
      <div class="col-auto">
        <base-button
          size="lg"
          type="secondary"
          class="btn-icon-only"
          @click="open = !open"
        >
          <span v-if="open"><i class="fas fa-folder-open"></i></span>
          <span v-else><i class="fas fa-folder"></i></span>
        </base-button>
      </div>

      <!-- <div class="col" v-if="editFolderMode">
            <base-input
              v-model="folder.display"
              @input="renameFolder($event, folder.id)"
            />
          </div> -->

      <div class="col-form-label">
         <span class="numberBlock">
            {{ dels.length }}
          </span>
          <span>
            {{ groupName }}
          </span>

      </div>
      <!-- <div class="col-auto" v-if="editFolderMode">
            <base-button
              type="danger"
              class="btn-icon-only"
              @click="deleteFolder(folder.id)"
            >
              <span><i class="fas fa-folder-minus"></i></span>
            </base-button>
          </div>-->
    </div>
    <div v-if="open">
      <div>
        <masonry
          :cols="{ default: 5, 1400: 4, 1024: 3, 768: 2, 576: 1 }"
          :gutter="30"
        >
          <div v-for="item in dels" :key="item.id">
            <catalogue-card
              v-if="item.currentFileID"
              :del="item"
              :collection="true"
            >
            </catalogue-card>
            <card v-else-if="item.__kind === 'archiveEvent'">
              <file-preview
                slot="image"
                class="card-img-top"
                :fileID="item.clipFile"
                :useVideoJs="true"
              ></file-preview>
              <div class="h5 card-title mb-2">
                {{ item.bookmark || item.note || "Archive clip" }}
              </div>
              <div class="text-muted mb-2">
                {{ item.date || "" }}
              </div>
              <div class="mt-2">
                <a download class="btn btn-sm" :href="`/#/recording/${item.file}/${item.id}`">
                  <i class="fa fa-download worklistIcon"></i>
                </a>
                <base-button
                  size="sm"
                  type="warning"
                  @click="removeEventFromCollection(item)"
                >
                  Remove
                </base-button>
              </div>
            </card>
            <card v-else>
              <file-preview
                slot="image"
                class="card-img-top"
                :file="item"
                :useVideoJs="true"
              ></file-preview>
              <div class="h5 card-title mb-2">
                {{ item.sourceFileNameAsUploaded || item.sourceFileName || item.label || "Collection file" }}
              </div>
              <div class="text-muted mb-2" v-if="item.created_at">
                {{ item.created_at | date }}
              </div>
              <div class="mt-2">
                <a download class="btn btn-sm" :href="item.sourceDownloadURL">
                  <i class="fa fa-download worklistIcon"></i>
                </a>
                <base-button size="sm" type="danger" @click="deleteFile(item.id)">Delete</base-button>
              </div>
            </card>
          </div>
        </masonry>
      </div>
    </div>
  </div>
</template>

<script>
import CatalogueCard from "./CatalogueCard";

// style import
import "sweetalert2/dist/sweetalert2.css";

export default {
  name: "widgetGroups",
  data: function () {
    return {
      open: true,
    };
  },
  props: ["groupName", "dels", "colId"],
  components: {
    "catalogue-card": CatalogueCard,
  },
  computed: {
    user() {
      return this.$store.getters["user/user"];
    },

    config() {
      return this.$store.getters["config/config"];
    },

    groups() {
      return Object.keys(this.groupedDels);
    },
  },
  beforeMount() {},
  methods: {
    removeEventFromCollection(event) {
      const current = Array.isArray(event.collections) ? event.collections : [];
      const next = current.filter((id) => id !== this.colId);
      this.$store.dispatch("archiveEvents/patch", {
        id: event.id,
        collections: next,
      });
    },
    deleteFile(id) {
      this.$store.dispatch("files/delete", id);
    },
  },
};
</script>

<style>
/* ul.folders > li {
  background: #f8f8f8;
} */
</style>
